import React from "react";
import { DivideIcon as LucideIcon } from "lucide-react";

interface FeatureCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  className?: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon: Icon,
  title,
  description,
  className = "",
}) => {
  return (
    <div className={`flex flex-col justify-start items-center ${className}`}>
      {/* <div className="p-4 rounded-full  inline-block mb-4 group-hover:bg-primary-light/20 transition-colors">
        <Icon size={24} className="text-primary" />
      </div> */}
      <h3 className="text-xl font-heading font-semibold mb-3 text-gray-800 text-center">
        {title}
      </h3>
      <p className="px-4 text-gray-600 text-center">{description}</p>
    </div>
  );
};

export default FeatureCard;
